export function useShouldAutoInitialize() {
    return !window.location.hash.includes("access_token");
}
